import { useState, useEffect } from 'react';
import isBrowser from 'is-browser';

/**
 * Hook to track the current window width
 * @returns The current window width in pixels
 */
export const useWidth = (): number => {
  const [width, setWidth] = useState<number>(isBrowser ? window.innerWidth : 0);

  useEffect(() => {
    if (!isBrowser) return;

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Set initial width
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};
